const OTHER_PRESCRIPTION_MESSAGES = {
  PAGE_HEADINGS: {
    TITLE: 'Non Speciality Drugs',
    SUB_TITLE:
      'Metrics on pharmacy spend and the drug types with the highest plan impact.',
  },
  OVERVIEW_CARDS: {
    MEMBERS: 'Cohort Members',
    COST: 'Cohort Cost',
    PMPM: 'Cohort PMPM',
    PEPM: 'Cohort PEPM',
  },
  DRUG_CATEGORIES_CHART: {
    TITLE: 'Drug categories of Non Cancer',
  },
  TOP_DRUGS_TABLE: {
    TITLE: 'Top Drugs by Non-Speciality',
    TITLE1: 'Top Drugs',
    SUBTITLE:
      'You can view the drugs in different categories of Medpharma, Specialty and Non-Speciality by clicking on the dropdown',
    DROPDOWN_DISPLAY_VALUES: [
      'All Drugs',
      'Medpharma',
      'Specialty',
      'Non-Speciality',
    ],
    DROPDOWN_VALUES: [
      'All Drugs',
      'Medpharma',
      'Speciality Drug',
      'Non-Speciality Drug',
    ],
  },
  MAIN_SORT_COLUMN: 'totalCost',
  MAIN_SORT_ORDER: -1,
  SOMETHING_WENT_WRONG:
    'Something went wrong. Try again after sometime or Please reachout to support team',
  NO_DATA_DRUGS: 'We do not see drug usage in this category',
};

export default OTHER_PRESCRIPTION_MESSAGES;
